<script>
import { Helper } from '@/mixin/helper'
import McGraphqlEditableTable from '@/components/McGraphqlEditableTable'
import * as fuelApi from '@/services/api/setting/fleet/fuelType'

export default {
  components: { McGraphqlEditableTable },
  mixins: [Helper],
  props: {
    status: String,
  },
  data() {
    return {
      data: [],
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'name',
          label: this.$t('setting.list.fleetSetting.fuelType'),
          thClass: 'mc-table--50',
          isSortable: true,
          isEditable: false,
        },
        {
          key: 'price',
          label: this.$t('setting.list.fleetSetting.priceLiter'),
          thClass: 'mc-table--50',
          isSortable: false,
          editable: true,
          type: 'number',
          validation: 'required|max:6,length|min:0,value',
        },
      ]
    },
    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: fuelApi.GET_FUEL_TYPES,
            variables: {
              filter: filter,
            },
          })
          let self = this
          const result = res.data.fuelTypePrices.fuelTypePrices
          result.data.forEach((item, index) => {
            result.data[index].id = item.fuelType.fuelTypeId
            result.data[index].name = item.fuelType.name
            result.data[index].disableCheckbox = true
          })
          self.data = result.data
          return result
        },
        show: async (filter) => {
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: fuelApi.GET_FUEL_TYPE,
            variables: {
              filter: filter,
            },
          })
          let self = this
          self.data = res.data.fuelTypePrice.fuelTypePrice.data

          return res.data.fuelTypePrice.fuelTypePrice
        },
        store: async (data) => {
          const res = await this.$apollo.mutate({
            mutation: fuelApi.CREATE_FUEL_TYPE,
            variables: {
              input: {
                price: data.price,
              },
            },
          })

          return res.data.createFuelTypePrice.isSuccessful
        },
        update: async (id, oldData, newData) => {
          const res = await this.$apollo.mutate({
            mutation: fuelApi.UPDATE_FUEL_TYPE,
            variables: {
              input: {
                fuelTypeId: Number(id),
                oldData: {
                  price: Number(oldData.price),
                },
                newData: {
                  price: Number(newData.price),
                },
              },
            },
          })
          const updateData = res.data.updateFuelTypePrice.fuelTypePrice
          return updateData
        },
        delete: async (id) => {
          const res = await this.$apollo.mutate({
            mutation: fuelApi.DELETE_FUEL_TYPE,
            variables: {
              input: {
                fuelTypeId: Number(id),
              },
            },
          })
          return res.data.deleteFuelTypePrice.isSuccessful
        },
      }
    },
  },
  mounted() {
    this.$store.commit('setting/SET_STATUS', this.status)
  },
}
</script>
<template>
  <b-tab class="border-0" @click="$store.commit('setting/SET_STATUS', status)">
    <template #title>
      <span class="d-sm-inline-block">{{ $t('setting.list.fleetSetting.fuelType') }}</span>
    </template>
    <div class="table-responsive my-3">
      <McGraphqlEditableTable
        :fields="fields"
        :apiClient="query"
        :searchable="true"
        :canCreate="false"
        :canDelete="false"
        :canSelect="false"
      />
    </div>
  </b-tab>
</template>
